const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

// 13 mois, durée maximale recommandée par la CNIL pour un cookie de préférence.
const COOKIE_MAX_AGE = 13 * 30 * 24 * 60 * 60;

/**
 * @param {string} name
 * @returns {string|null}
 */
const readCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));

  return match ? decodeURIComponent(match[1]) : null;
};

/**
 * @param {string} name
 * @param {string} value
 */
const writeCookie = (name, value) => {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';

  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax${secure}`;
};

const Popin = () => {
  const popin = document.querySelector('.js-popin');

  if (!popin) {
    return;
  }

  // Téléporté dans le body pour échapper aux contextes de positionnement du layout.
  document.body.appendChild(popin);

  const { popinCookie: cookieName, popinVersion: version } = popin.dataset;

  // La version change dès que le concessionnaire modifie sa pop-in : elle est
  // alors réaffichée, même si l'utilisateur l'avait déjà fermée.
  if (cookieName && version && readCookie(cookieName) === version) {
    return;
  }

  const backdrop = popin.querySelector('.js-popin-backdrop');
  const closeButton = popin.querySelector('.js-popin-close');
  const cta = popin.querySelector('.js-popin-cta');
  let lastFocused = null;

  const remember = () => {
    if (cookieName && version) {
      writeCookie(cookieName, version);
    }
  };

  const open = () => {
    lastFocused = document.activeElement;
    popin.hidden = false;
    popin.classList.add('-open');
    document.body.style.overflow = 'hidden';
    closeButton?.focus();
  };

  const close = () => {
    remember();
    popin.classList.remove('-open');
    popin.hidden = true;
    document.body.style.overflow = '';

    if (lastFocused instanceof HTMLElement) {
      lastFocused.focus();
    }
  };

  closeButton?.addEventListener('click', close);
  backdrop?.addEventListener('click', close);
  // Un clic sur le CTA est une conversion : ne plus solliciter l'utilisateur.
  cta?.addEventListener('click', remember);

  popin.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      close();

      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const items = [...popin.querySelectorAll(FOCUSABLE)].filter((item) => item.offsetParent !== null);

    if (!items.length) {
      return;
    }

    const first = items[0];
    const last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  open();
};

export default Popin;
